import {
  fetchCollection,
  fetchResource,
  createResource,
  performActionOnResource,
  updateResource,
  deleteResource,
  baseRequest
} from './index'

import imageToDataURI from '../helpers/imageToDataURI'

import get from 'lodash/get'
import { issueSchema } from '../schemas'
import FileSaver from 'file-saver'

export const LOCATION_ISSUES_CSV_REQUEST = 'LOCATION_ISSUES_CSV_REQUEST'
export const LOCATION_ISSUES_CSV_SUCCESS = 'LOCATION_ISSUES_CSV_SUCCESS'
export const LOCATION_ISSUES_CSV_FAILURE = 'LOCATION_ISSUES_CSV_FAILURE'

export function downloadCSV (id) {
  return baseRequest({
    url: `/locations/${id}/issues/csv_export`,
    method: 'GET',
    actions: [ LOCATION_ISSUES_CSV_REQUEST, LOCATION_ISSUES_CSV_SUCCESS, LOCATION_ISSUES_CSV_FAILURE ],
    responseInterceptor: (data, response) => {
      let file = new File([data.result], data.filename, { type: "text/csv" })
      FileSaver.saveAs(file)
    }
  })
}

export const LOCATION_ISSUES_REQUEST = 'LOCATION_ISSUES_REQUEST'
export const LOCATION_ISSUES_SUCCESS = 'LOCATION_ISSUES_SUCCESS'
export const LOCATION_ISSUES_FAILURE = 'LOCATION_ISSUES_FAILURE'

function fetchIssuesForLocation (locationId, url, reload) {
  return fetchCollection({
    url,
    key: 'issues',
    schema: issueSchema,
    actions: [ LOCATION_ISSUES_REQUEST, LOCATION_ISSUES_SUCCESS, LOCATION_ISSUES_FAILURE ],
    responseInterceptor: (response) => ({ ...response, locationId, reload })
  })
}

export function loadIssuesForLocation (locationId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.issuesByLocation.${locationId}`, {})

    if (!nextPage) {
      nextPageUrl = `/locations/${locationId}/issues`
    }

    return dispatch(fetchIssuesForLocation(locationId, nextPageUrl, !nextPage))
  }
}

export const SERVICING_ISSUES_REQUEST = 'SERVICING_ISSUES_REQUEST'
export const SERVICING_ISSUES_SUCCESS = 'SERVICING_ISSUES_SUCCESS'
export const SERVICING_ISSUES_FAILURE = 'SERVICING_ISSUES_FAILURE'

function fetchIssuesForServicing (servicingId, url, reload) {
  return fetchCollection({
    url,
    key: 'issues',
    schema: issueSchema,
    query: { servicingId },
    actions: [ SERVICING_ISSUES_REQUEST, SERVICING_ISSUES_SUCCESS, SERVICING_ISSUES_FAILURE ],
    responseInterceptor: (response) => ({ ...response, servicingId, reload })
  })
}

export function loadIssuesForServicing (locationId, servicingId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.issuesByServicing.${servicingId}`, {})

    if (!nextPage) {
      nextPageUrl = `/locations/${locationId}/issues`
    }

    return dispatch(fetchIssuesForServicing(servicingId, nextPageUrl, !nextPage))
  }
}

export const AREA_ISSUES_REQUEST = 'AREA_ISSUES_REQUEST'
export const AREA_ISSUES_SUCCESS = 'AREA_ISSUES_SUCCESS'
export const AREA_ISSUES_FAILURE = 'AREA_ISSUES_FAILURE'

function fetchIssuesForArea (areaId, url, reload) {
  return fetchCollection({
    url,
    key: 'issues',
    schema: issueSchema,
    query: { areaId },
    actions: [ AREA_ISSUES_REQUEST, AREA_ISSUES_SUCCESS, AREA_ISSUES_FAILURE ],
    responseInterceptor: (response) => ({ ...response, areaId, reload })
  })
}

export function loadIssuesForArea (locationId, areaId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.issuesByArea.${areaId}`, {})

    if (!nextPage) {
      nextPageUrl = `/locations/${locationId}/issues`
    }

    return dispatch(fetchIssuesForArea(areaId, nextPageUrl, !nextPage))
  }
}

export const ISSUE_FETCH_REQUEST = 'ISSUE_FETCH_REQUEST'
export const ISSUE_FETCH_SUCCESS = 'ISSUE_FETCH_SUCCESS'
export const ISSUE_FETCH_FAILURE = 'ISSUE_FETCH_FAILURE'

export function getIssue (issueId) {
  return fetchResource({
    url: `/issues/${issueId}`,
    schema: issueSchema,
    key: 'issue',
    actions: [ ISSUE_FETCH_REQUEST, ISSUE_FETCH_SUCCESS, ISSUE_FETCH_FAILURE ]
  })
}

export const ISSUE_UPDATE_REQUEST = 'ISSUE_UPDATE_REQUEST'
export const ISSUE_UPDATE_SUCCESS = 'ISSUE_UPDATE_SUCCESS'
export const ISSUE_UPDATE_FAILURE = 'ISSUE_UPDATE_FAILURE'

export function updateIssue (issueId, data) {
   return (dispatch) => encodeIssueImage(data).then(() => dispatch(
     updateResource({
      url: `/issues/${issueId}`,
      key: 'issue',
      schema: issueSchema,
      data,
      actions: [ ISSUE_UPDATE_REQUEST, ISSUE_UPDATE_SUCCESS, ISSUE_UPDATE_FAILURE ]
    })
  ))
}

export const ISSUE_RESOLVE_REQUEST = 'ISSUE_RESOLVE_REQUEST'
export const ISSUE_RESOLVE_SUCCESS = 'ISSUE_RESOLVE_SUCCESS'
export const ISSUE_RESOLVE_FAILURE = 'ISSUE_RESOLVE_FAILURE'

export function markIssueAsResolved (issueId) {
  return performActionOnResource({
    url: `/issues/${issueId}`,
    action: 'mark_as_resolved',
    key: 'issue',
    schema: issueSchema,
    actions: [ ISSUE_RESOLVE_REQUEST, ISSUE_RESOLVE_SUCCESS, ISSUE_RESOLVE_FAILURE ]
  })
}

export const DELETE_ISSUE_REQUEST = 'DELETE_ISSUE_REQUEST'
export const DELETE_ISSUE_SUCCESS = 'DELETE_ISSUE_SUCCESS'
export const DELETE_ISSUE_FAILURE = 'DELETE_ISSUE_FAILURE'

export function deleteIssue (issueId, locationId) {
  return deleteResource({
    url: `/issues/${issueId}`,
    actionPayload: { locationId, resourceId: issueId },
    actions: [ DELETE_ISSUE_REQUEST, DELETE_ISSUE_SUCCESS, DELETE_ISSUE_FAILURE ],
    responseInterceptor: response => ({ ...response, issueId })
  })
}

export const CREATE_ISSUE_REQUEST = 'CREATE_ISSUE_REQUEST'
export const CREATE_ISSUE_SUCCESS = 'CREATE_ISSUE_SUCCESS'
export const CREATE_ISSUE_FAILURE = 'CREATE_ISSUE_FAILURE'

export function createIssueForLocation (locationId, data) {
  return (dispatch) => encodeIssueImage(data).then(() => dispatch(
    createResource({
      url: `/locations/${locationId}/issues`,
      data,
      key: 'issue',
      schema: issueSchema,
      actions: [ CREATE_ISSUE_REQUEST, CREATE_ISSUE_SUCCESS, CREATE_ISSUE_FAILURE ],
      responseInterceptor: response => ({ ...response, locationId })
    })
  ))
}

export const BACKLOG_ISSUE_REQUEST = 'BACKLOG_ISSUE_REQUEST'
export const BACKLOG_ISSUE_SUCCESS = 'BACKLOG_ISSUE_SUCCESS'
export const BACKLOG_ISSUE_FAILURE = 'BACKLOG_ISSUE_FAILURE'

export function sendIssueToBacklog (issueId, data) {
  return performActionOnResource({
    url: `/issues/${issueId}`,
    action: 'send_to_backlog',
    key: 'issue',
    schema: issueSchema,
    body: data,
    actions: [ BACKLOG_ISSUE_REQUEST, BACKLOG_ISSUE_SUCCESS, BACKLOG_ISSUE_FAILURE ]
  })
}

export const WORK_ORDER_ISSUE_REQUEST = 'WORK_ORDER_ISSUE_REQUEST'
export const WORK_ORDER_ISSUE_SUCCESS = 'WORK_ORDER_ISSUE_SUCCESS'
export const WORK_ORDER_ISSUE_FAILURE = 'WORK_ORDER_ISSUE_FAILURE'

export function sendIssueToWorkOrder (issueId, data) {
  return performActionOnResource({
    url: `/issues/${issueId}`,
    action: 'send_to_work_order',
    key: 'issue',
    schema: issueSchema,
    body: data,
    actions: [ WORK_ORDER_ISSUE_REQUEST, WORK_ORDER_ISSUE_SUCCESS, WORK_ORDER_ISSUE_FAILURE ]
  })
}

function encodeIssueImage (data) {
  return imageToDataURI(data.image)
    .then((encoded) => { data.image = encoded })
}



// WEBPACK FOOTER //
// ./src/actions/issues.js